import HandshakeIcon from './HandshakeIcon'

export default HandshakeIcon
